import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import styled from "@emotion/styled";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
// import { registerTenant, verifyEmail } from "../../actions/tenantActions";
import {
  Box,
  Flex,
  Image,
  Heading,
  Text,
  Spinner,
  VStack,
  Button,
  Tooltip,
} from "@chakra-ui/react";
import {
  white,
  textPrimary,
  textSecondary,
  primaryAlt,
  buttonRed,
  buttonRedText,
} from "../../utils/colors";
// import { FaArrowLeft } from "react-icons/fa6";
import Agreement from "../../components/partials/Agreement";
import { motion } from "framer-motion";
import { logoutNoRedirect } from "../../actions/authActions";
import { useTranslation } from "react-i18next";
import testupscale from "../../assets/images/testupscale.png";
import dentacasa from "../../assets/icons/dentacasa.svg";
import noServices from "../../assets/images/empty-box.png";
import FormControlDefault from "../../components/input/FormControlDefault";
import {
  acceptInviteAction,
  getPublicInviteInfoAction,
} from "../../actions/publicActions";
import FormControlPassword from "../../components/input/FormControlPassword";
import LanguageButtonMain from "../../components/buttons/LanguageButtonMain";
import useIsMobile from "../../hooks/useIsMobile";

const InvitePage = () => {
  // GENERAL
  const { slug } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const isMobile = useIsMobile();

  // CONSTANTS
  const [show, setShow] = React.useState(false);

  const storedLanguage = localStorage.getItem("language");
  const initialLanguage = storedLanguage || "en"; // Default to 'en'
  const [currentLanguage, setCurrentLanguage] = useState(initialLanguage);

  const email = searchParams.get("email");

  // const [clinicName, setClinicName] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  // const [accepted, setAccepted] = useState(false);

  const [errors, setErrors] = useState({});

  // State for managing video load
  const [videoLoaded, setVideoLoaded] = useState(false);

  // REDUX
  const publicInviteInfo = useSelector((state) => state.publicInviteInfo);
  const { loading, error, success, info } = publicInviteInfo;

  // STEPS
  const [currentStep, setCurrentStep] = useState(0);

  // REDUX
  // const authLogin = useSelector((state) => state.authLogin);
  // const { userInfo } = authLogin;

  // const publicAcceptInvite = useSelector((state) => state.publicAcceptInvite);
  // const {
  //   loading: loadingAccept,
  //   error: errorAccept,
  //   success: successAccept,
  //   data,
  // } = publicAcceptInvite;

  // VALIDATION
  const isNameError = name === "";
  const doPasswordsMatch = password === repeatPassword;

  // Password validation: At least 6 characters and 1 number
  const passwordRegex = /^(?=.*\d).{6,}$/;
  const isPasswordEmpty = password === "";
  const isPasswordInvalid = !passwordRegex.test(password) && !isPasswordEmpty;

  // TOOLTIP VALIDATION MESSAGES
  const tooltipMessages = [];

  if (isNameError) tooltipMessages.push(t("formError.firstNameRequired"));

  // // Password error messages
  if (isPasswordEmpty) {
    tooltipMessages.push(t("formError.passwordRequired"));
  } else if (isPasswordInvalid) {
    tooltipMessages.push(t("formError.passwordInvalid"));
  }

  if (!doPasswordsMatch && repeatPassword) {
    tooltipMessages.push(t("formError.passwordMismatch"));
  }

  // USE EFFECT

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 100);
  }, [navigate]);

  useEffect(() => {
    // Always logout on entering invite page to prevent conflicts
    dispatch(logoutNoRedirect());

    if (email && token) {
      dispatch(getPublicInviteInfoAction(slug, email, token));
    }
  }, [dispatch, slug, email, token]);

  // HANDLERS

  // STEPS HANDLERS

  // SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(
        acceptInviteAction(
          email,
          password,
          name,
          slug,
          token,
          info.isGlobalUser,
          currentLanguage
        )
      );

      // After successful invite acceptance, log the user in
      // await dispatch(login(email, password, currentLanguage));

      // ✅ Optional: redirect to dashboard or tenant selector
      // navigate(`/${slug}/dashboard`);
      navigate(`/select-tenant`);
    } catch (err) {
      console.error("Invite or login failed", err.message);
      // Optionally show toast or error state
    }
  };

  // LOG
  // console.log("info", info);
  // console.log("data", data);

  return (
    <>
      <Helmet>
        <title>{t("pageTitle.invitePage")}</title>
        <meta name="description" content={t("pageDescription.invitePage")} />
      </Helmet>

      {/* )} */}

      {show && (
        <Flex
          w="100%"
          h="100%"
          minH="100vh"
          align="stretch"
          position="relative"
          justify="flex-start"
          bg={white}
          as={motion.div}
          exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
          initial={{ opacity: 0, x: 0, y: 0 }}
          animate={{
            opacity: 1,
            x: 0,
            y: 0,
            transition: { duration: 0.15 },
            // transition: { delay: 0.3, duration: 0.2 },
          }}
        >
          <Box
            position={["absolute", "fixed"]}
            top={["0rem", "2.5rem"]}
            left={["0rem", "2.5rem"]}
            // bg="green"
            p={["1.5rem 1.5rem", "initial"]}
            w={["100%", "100%"]}
            zIndex={1000}
          >
            <Flex w="100%" align="center" justify="space-between">
              <Link to="/">
                <Box h={["20px", "22px"]} w="initial">
                  <Image src={dentacasa} h="100%" w="initial" />
                </Box>
              </Link>
              <Flex align="center" justify="flex-end" gap="0rem">
                <LanguageButtonMain />
              </Flex>
            </Flex>
          </Box>

          <Box
            w={["100%", "29%"]}
            position={["fixed", "relative", "relative"]}
            h="100%"
            flexShrink={0}
            maxH={["100%", "100vh"]}
            display={["none", "flex"]}
          >
            <Flex w="100%" h="100%" position="relative">
              <Image src={testupscale} w="100%" h="100%" objectFit="cover" />
              <Flex
                position="fixed"
                zIndex="1"
                top="0"
                left="0"
                w="29%"
                h="100%"
                as={motion.div}
                initial={{ opacity: 0, y: 0 }}
                animate={{
                  opacity: 1,
                  y: 0,
                  transition: { delay: 0, duration: 1 },
                }}
              >
                <Video
                  playsInline
                  autoPlay
                  loop
                  muted
                  onLoadedData={() => setVideoLoaded(true)}
                  onError={() => setVideoLoaded(false)}
                  style={{ display: videoLoaded ? "block" : "none" }}
                  src="https://bucket.mailersendapp.com/0p7kx4xmrvl9yjre/z3m5jgr1omx4dpyo/files/9ca7a800-8d36-414c-a9f1-d5ac05d4a695/videonew2.mp4"
                ></Video>
              </Flex>
            </Flex>
          </Box>

          {!loading ? (
            <Flex
              w="100%"
              h={["100%", "100%", "100%"]}
              p={["12vh 1.5rem 8rem", "8rem 0px 6rem 100px"]}
              align="flex-start"
              justify={["flex-start", "center"]}
              direction="column"

              // maxH={["100%", "100vh"]}
            >
              {info && info.valid === true ? (
                <>
                  <form
                    onSubmit={handleSubmit}
                    style={{
                      width: "100%",
                      maxWidth: isMobile ? "100%" : "420px",
                    }}
                  >
                    {info && info.isGlobalUser === false ? (
                      <>
                        <Heading
                          fontSize="1.875rem"
                          fontWeight="700"
                          color={textPrimary}
                          // mb={6}
                        >
                          <Text
                            as="span"
                            mr={1.5}
                            color={primaryAlt}
                            textTransform="capitalize"
                          >
                            {info && info.clinicName}
                          </Text>
                          {t("user.invitePageTitle")}{" "}
                        </Heading>

                        <Text
                          color={textSecondary}
                          fontWeight="500"
                          size="sm"
                          m="0.5rem 0 1rem"
                        >
                          {t("user.invitePageText")}{" "}
                        </Text>

                        <VStack spacing={0} align="stretch" m="2rem 0 0">
                          <FormControlDefault
                            labelFontSize="0.8rem"
                            size="lg"
                            label={t("form.email")}
                            value={email}
                            isReadOnly
                            isRequired
                            error={errors.email}
                            errorMessage={errors.email}
                            onChange={() => {}}
                            isDisabled
                            isLabelEnabled
                          />

                          <FormControlDefault
                            labelFontSize="0.8rem"
                            size="lg"
                            label={t("form.firstName")}
                            value={name}
                            isRequired
                            placeholder={t("placeholder.firstName")}
                            error={errors.name}
                            errorMessage={errors.name}
                            onChange={(e) => {
                              setName(e.target.value);
                              setErrors((prev) => ({
                                ...prev,
                                name: e.target.value ? "" : "Name is required",
                              }));
                            }}
                          />

                          <FormControlPassword
                            labelFontSize="0.8rem"
                            size="lg"
                            label={t("form.password")}
                            value={password}
                            isRequired
                            placeholder={t("placeholder.password")}
                            error={errors.password}
                            errorMessage={errors.password}
                            onChange={(e) => {
                              setPassword(e.target.value);
                              setErrors((prev) => ({
                                ...prev,
                                password: e.target.value
                                  ? ""
                                  : "Password is required",
                              }));
                            }}
                            isLabelEnabled
                          />

                          <FormControlPassword
                            labelFontSize="0.8rem"
                            size="lg"
                            label={t("form.repeatPassword")}
                            value={repeatPassword}
                            isRequired
                            placeholder={t("placeholder.repeatPassword")}
                            error={
                              errors.repeatPassword ||
                              (!doPasswordsMatch && repeatPassword)
                            }
                            errorMessage={
                              !doPasswordsMatch && repeatPassword
                                ? t("formError.passwordMismatch")
                                : errors.repeatPassword
                            }
                            onChange={(e) => {
                              setRepeatPassword(e.target.value);
                              setErrors((prev) => ({
                                ...prev,
                                repeatPassword: e.target.value
                                  ? ""
                                  : t("formError.repeatRequired"),
                              }));
                            }}
                            isLabelEnabled
                          />
                        </VStack>

                        <Flex w="100%" m="0rem 0 " direction="column">
                          <Box p="0.5rem 0">
                            <Agreement noQuestion />
                          </Box>

                          <Tooltip
                            bg={buttonRed}
                            color={buttonRedText}
                            padding="0.5rem 1rem"
                            borderRadius="1rem"
                            placement="top"
                            label={
                              tooltipMessages.length > 0 ? (
                                <Flex
                                  direction="column"
                                  justify="center"
                                  align="center"
                                >
                                  {tooltipMessages.map((message, index) => (
                                    <Text
                                      key={index}
                                      color={buttonRedText}
                                      fontSize="xs"
                                      fontWeight="500"
                                      textAlign="center"
                                    >
                                      {message}
                                    </Text>
                                  ))}
                                </Flex>
                              ) : null
                            }
                            isDisabled={tooltipMessages.length === 0} // Disable tooltip if no errors
                          >
                            <Button
                              type="submit"
                              m="1rem 0 0"
                              h="3rem"
                              borderRadius="10rem"
                              bg={textPrimary}
                              color={white}
                              border={`1px solid ${textPrimary}`}
                              textAlign="center"
                              w="100%"
                              _hover={{
                                // bg: "rgba(13, 12, 34, 0.8)",
                                bg: primaryAlt,
                                color: white,
                                // border: `rgba(13, 12, 34, 0.8)`,
                                border: primaryAlt,
                              }}
                              isDisabled={tooltipMessages.length > 0} // Disable if any errors exist
                            >
                              {t("common.register")}
                            </Button>
                          </Tooltip>
                        </Flex>
                      </>
                    ) : (
                      <>
                        <Heading
                          fontSize={["1.75rem", "1.875rem"]}
                          fontWeight="700"
                          color={textPrimary}
                          // mb={6}
                        >
                          <Text
                            as="span"
                            mr={1.5}
                            color={primaryAlt}
                            textTransform="capitalize"
                          >
                            {info && info.clinicName}
                          </Text>
                          {t("user.inviteAcceptTitle")}{" "}
                        </Heading>

                        <Text
                          color={textSecondary}
                          fontWeight="500"
                          size={["md", "sm"]}
                          m="1rem 0 1rem"
                        >
                          {t("user.inviteAcceptTextFirst")}{" "}
                          <Text as="span" color={textPrimary}>
                            {email}{" "}
                          </Text>
                          <Text as="span">
                            {t("user.inviteAcceptTextSecond", {
                              clinicName: info && info.clinicName,
                            })}
                          </Text>
                        </Text>

                        <VStack spacing={0} align="stretch" m="0rem 0 0">
                          <Flex w="100%" m="0rem 0 " direction="column">
                            <Box p="0.5rem 0">
                              {/* <Agreement noQuestion /> */}
                            </Box>

                            <Button
                              type="submit"
                              m="1rem 0 0"
                              h="3rem"
                              borderRadius="10rem"
                              bg={textPrimary}
                              color={white}
                              border={`1px solid ${textPrimary}`}
                              textAlign="center"
                              w="100%"
                              _hover={{
                                // bg: "rgba(13, 12, 34, 0.8)",
                                bg: primaryAlt,
                                color: white,
                                // border: `rgba(13, 12, 34, 0.8)`,
                                border: primaryAlt,
                              }}
                            >
                              {t("user.confirmInvite")}
                            </Button>
                          </Flex>
                        </VStack>
                      </>
                    )}
                  </form>
                </>
              ) : info && info.valid === false ? (
                <Flex
                  w="100%"
                  align="center"
                  justify="center"
                  // pl="100px"
                  direction="column"
                  maxW={["100%", "600px"]}
                  minH={["initial", "600px"]}
                >
                  <Image h="4rem" w="auto" m="0rem 0 0" src={noServices} />
                  <Text
                    color={textPrimary}
                    fontSize="1.875rem"
                    fontWeight="700"
                    m="1.5rem 0 0.5rem"
                    textAlign="center"
                  >
                    {t("user.invitePageInvalid")}
                  </Text>
                  <Text
                    color={textSecondary}
                    fontSize="md"
                    fontWeight="500"
                    textAlign="center"
                  >
                    {t("user.invitePageInvalidText")}
                  </Text>
                </Flex>
              ) : info && info.valid === false ? (
                <Flex
                  w="100%"
                  align="center"
                  justify="center"
                  // pl="100px"
                  direction="column"
                  maxW={["100%", "600px"]}
                  minH={["initial", "600px"]}
                >
                  <Image h="4rem" w="auto" m="0rem 0 0" src={noServices} />
                  <Text
                    color={textPrimary}
                    fontSize="1.875rem"
                    fontWeight="700"
                    m="1.5rem 0 0.5rem"
                    textAlign="center"
                  >
                    {t("user.invitePageInvalid")}
                  </Text>
                  <Text
                    color={textSecondary}
                    fontSize="md"
                    fontWeight="500"
                    textAlign="center"
                  >
                    {t("user.invitePageInvalidText")}
                  </Text>
                </Flex>
              ) : (
                <Flex
                  w="100%"
                  align="center"
                  justify="center"
                  // pl="100px"
                  direction="column"
                  maxW={["100%", "600px"]}
                  minH={["initial", "600px"]}
                >
                  <Image h="4rem" w="auto" m="0rem 0 0" src={noServices} />
                  <Text
                    color={textPrimary}
                    fontSize="1.875rem"
                    fontWeight="700"
                    m="1.5rem 0 0.5rem"
                    textAlign="center"
                  >
                    {t("user.noInviteTitle")}
                  </Text>
                  <Text
                    color={textSecondary}
                    fontSize="md"
                    fontWeight="500"
                    textAlign="center"
                  >
                    {t("user.noInviteText")}
                  </Text>
                </Flex>
              )}
            </Flex>
          ) : (
            <Flex
              w="100%"
              align="flex-start"
              justify="center"
              pl="300px"
              direction="column"
              ma
            >
              <Spinner size="lg" color={primaryAlt} />
            </Flex>
          )}
        </Flex>
      )}
    </>
  );
};

const Video = styled.video`
  display: block;
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
`;

export default InvitePage;
